import en from './en.json';
import fr from './fr.json';

export const uploadI18n = {
  fr,
  en,
};
